import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../components/Layout';
import ImageGallery from './Components/ImageGallery';
import moment from 'moment';
import { useSelector } from 'react-redux';
import ReactDatePicker from 'react-datepicker';
import { getMonitor } from '../../services';
import _ from "lodash";

export default function ScreenShots() {
  const [startDate, setStartDate] = useState(moment().startOf("day").toDate());
  const [endDate, setEndDate] = useState(moment().toDate());
  const datePickerRef = useRef(null);
  const [isViewAll, setIsViewAll] = useState(true);
  const [selectedMember, setSelectedMember] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [monitor, setMonitor] = useState([]);
  const [offset, setOffset] = useState(0);
  let [TotalCount, setTotalCount] = useState(0)
  const [firstLoad, setFirstLoad] = useState(true); // Flag for first load
  const bottomRef = useRef(null);

  
  const members = useSelector((state) => state.members.members);

  const FetchMonitor = async (memberid, fromdate, todate, offset) => {
    setIsLoading(true);
    try {
      if (!startDate || !endDate) {
        console.error("Start date or end date is undefined");
        return;
      }


      const formattedStartDate = moment(fromdate).format("YYYY-MM-DD");
      const formattedEndDate = moment(todate).format("YYYY-MM-DD")

      // Fetch data from API
      const response = await getMonitor(memberid, formattedStartDate, formattedEndDate, offset, "12");

      if (response?.data?.Result) {
        if (selectedMember) {
          setIsViewAll(false)
        } else {
          setIsViewAll(true)
        }

        setMonitor(prevMonitor => [...prevMonitor, ...response.data.Result.MonitorList]);
        setTotalCount(response.data.Result.TotalCount);
      } else {
        console.log("Hi")
        setMonitor([])
      }
    } catch (error) {
      setMonitor([])
      console.error('Error fetching monitor:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const setDateRange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const handleMemberSelect = (member) => {
    setSelectedMember(member);
    setDropdownOpen(false);
  };

  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  useEffect(() => {
    if (firstLoad && offset === 0) {
      // Trigger the first fetch without the offset
      FetchMonitor("", startDate, endDate, offset);
      setFirstLoad(false);  // Set first load to false after triggering
    }
  }, []);

  // Effect to trigger API when the offset changes (after scrolling)
  useEffect(() => {
    if (offset > 0) {
      FetchMonitor(selectedMember.Id || "", startDate, endDate, offset); // Trigger fetch on offset change
    }
  }, [offset]);

  const handleScroll = () => {
    if (bottomRef.current) {
      const bottom = bottomRef.current.getBoundingClientRect();

      if (bottom.top <= window.innerHeight && monitor.length !== TotalCount && !isLoading) {
        setIsLoading(true);
        setOffset((prevOffset) => prevOffset + 12);
        // Your API call or other action here
      }
    }
  };


  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [offset, monitor, TotalCount]);;

  return (
    <Layout>
      <div>
        <h2 className="text-left text-gray-900 font-medium text-3xl dark:text-white">
          Monitor
        </h2>
      </div>
      <div className='border flex flex-col dark:border-gray-900 border-gray-300 ' style={{ minHeight: "calc(100vh - 150px)" }}>
        <div className="text-lg font-medium text-center text-gray-600 dark:text-gray-400">
          <div className="flex flex-row items-center space-x-5 bg-gray-300 dark:bg-[#1c1c1f] p-3">
            <div className="relative">
              <button
                className="w-72 py-2.5 px-2 text-sm text-gray-600 bg-transparent border-b-2 border-gray-200 dark:text-gray-300 dark:border-gray-700 focus:outline-none flex items-center justify-between"
                onClick={toggleDropdown}
              >
                <span className="">
                  {selectedMember
                    ? selectedMember?.MemberName
                    : "All Members"}
                </span>
                <svg
                  className="w-5 h-5 text-gray-800 dark:text-gray-500"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m19 9-7 7-7-7"
                  />
                </svg>
              </button>
              {dropdownOpen && (
                <ul
                  className="absolute z-50 block w-72 bg-gray-50 border border-gray-300 rounded-md mt-2 shadow-lg dark:bg-gray-800 dark:border-gray-700 
                 max-h-[170px] overflow-y-scroll 
                 [&::-webkit-scrollbar]:w-2 
                 [&::-webkit-scrollbar-track]:rounded-full 
                 [&::-webkit-scrollbar-track]:bg-gray-100 
                 [&::-webkit-scrollbar-thumb]:rounded-full 
                 [&::-webkit-scrollbar-thumb]:bg-gray-300 
                 dark:[&::-webkit-scrollbar-track]:bg-gray-800 
                 dark:[&::-webkit-scrollbar-thumb]:bg-gray-700"
                >
                  <li
                    className="text-sm p-1 text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-500 dark:hover:text-white cursor-pointer"
                    value={selectedMember}

                    onClick={() => handleMemberSelect("")}
                  >
                    All Members
                  </li>
                  {members?.length > 0 ? (
                    members.map((member) => (
                      <li
                        key={member.Id}
                        className="px-4 py-1 text-gray-700 text-base hover:bg-gray-300 dark:text-gray-200 dark:hover:bg-gray-600 dark:hover:text-gray-300 cursor-pointer"
                        onClick={() => handleMemberSelect(member)}
                      >
                        {member.MemberName}
                      </li>
                    ))
                  ) : (
                    <li className="px-4 py-2 text-sm text-gray-400 dark:text-gray-500">
                      No members available
                    </li>
                  )}
                </ul>
              )}
            </div>

            <div className="relative max-w-sm">
              <ReactDatePicker
                ref={datePickerRef}
                selected={startDate}
                onChange={setDateRange}
                startDate={startDate}
                endDate={endDate}
                dateFormat="yyyy/MM/dd"
                selectsRange
                maxDate={new Date()}
                className="w-60 py-2.5 px-2 text-sm text-gray-500 bg-transparent border-b-2 border-gray-200 dark:text-gray-300 dark:border-gray-700 focus:outline-none flex items-center justify-between"
              />

              <svg
                onClick={handleIconClick}
                className="absolute top-[9px] right-0 w-6 h-6 text-gray-800 dark:text-gray-400 cursor-pointer"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 10h16m-8-3V4M7 7V4m10 3V4M5 20h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Zm3-7h.01v.01H8V13Zm4 0h.01v.01H12V13Zm4 0h.01v.01H16V13Zm-8 4h.01v.01H8V17Zm4 0h.01v.01H12V17Zm4 0h.01v.01H16V17Z"
                />
              </svg>
            </div>

            <div>
              <button
                type="button"
                className="text-white px-10 py-2 mt-1 bg-blue-900 hover:bg-sky-700 focus:outline-none focus:ring-blue-300 font-medium rounded text-sm text-center dark:bg-blue-600 dark:hover:bg-blue-900 dark:focus:ring-blue-900"
                onClick={() => {
                  setOffset(0);
                  setMonitor([]);
                  FetchMonitor(selectedMember.Id, startDate, endDate, 0); // Make the API call with reset offset
                }}
                disabled={isLoading}
              >
                {isLoading ? (
                  <svg
                    aria-hidden="true"
                    className="w-6 h-6 animate-spin dark:text-gray-400 fill-blue-600 dark:fill-white"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                ) : (
                  "Search"
                )}
              </button>
            </div>
          </div>

        </div>
        <div className='m-3'>
          {!_.isEmpty(monitor) ?
            <>
              <ImageGallery
                monitor={monitor}
                isViewAll={isViewAll}
              />
            </> :
            <h3
              className="whitespace-nowrap text-[17px] font-medium text-gray-500 dark:text-gray-400 text-center"
            >There is no activity captured yet</h3>
          }
        </div>

        {isLoading && (
          <div className='text-center mt-auto my-5 py-3 bg-gray-300 dark:bg-[#1c1c1f]'>
            <svg
              aria-hidden="true"
              className="w-10 h-10 inline-block animate-spin dark:text-gray-400 fill-blue-600 dark:fill-white"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
          </div>

        )}
        <div ref={bottomRef} className="h-1" />
      </div >
    </Layout >
  );
}
